/*****************************************

jQuery.syg_pagescroll
version 1.3
Hiroshi Fukuda <dada@sygnas.jp>
http://sygnas.jp/

The MIT License

Copyright (c) 2011-2012 Hiroshi Fukuda, http://sygnas.jp/

/*****************************************


/*****************************************
= example 1 =

	<a href="#hogehoge">hogehoge</a>

	<div id="hogehoge">
	</div>

	<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
	<script>
		new $.SygPageScroll( 'a' );
	</script>


= example 2 =

	<a href="#hogehoge" class="scroll">hogehoge</a>

	<div id="hogehoge">
	</div>

	<script src="lib/jquery.easing.1.3.js"></script>
	<script src="lib/jquery.syg_pagescroll.1.0.js"></script>
	<script>
		new $.SygPageScroll( 'a.scroll', {time:2000, easing:'easeInOutCubic'} );
	</script>

*****************************************/

/*****************************************

2016.11.23 ver.2.1
	・$(target).click(); を $(document).on('click',target,function(){}); に変更
2016.06.8 ver 2
	・Webpack用に作り直し
2015.04.26 ver 1.3
	・スクロール先IDが無い場合は普通にリンクさせる
2013.03.08 ver 1.1
	・位置補正オプション「plus」を追加。

*****************************************/

var CaracolPageScroll;

module.exports = CaracolPageScroll = function( target, config ){
	'use strict';

	var defaults = {
		easing:			'swing',
		time:			1000,
		plus:			0
	};

	this.opt = $.extend( defaults, config );

	var self = this;
	var opt = this.opt;

	/*****************************
	* click setting
	*/
	$(document).on('click',target,
		$.proxy(
			function( e ){
				var hash = e.currentTarget.hash;

				if( $(hash).get(0) ){
					var y = $(hash).offset().top +opt.plus;
					$('html,body').animate( {scrollTop:y}, self.opt.time, self.opt.easing );
					return false;
				}else{
					return true;
				}

			}
		)
	);

};




/*****************
 ** WEBPACK FOOTER
 ** /Users/dada/www/_template/.src/js/caracol2.0.0/effect/pagescroll.js
 ** module id = 6
 ** module chunks = 0
 **/